// extracted by mini-css-extract-plugin
module.exports =  {"container":"VfOJ5u4TA_Uh__cuA_C2"};